<template>
  <v-dialog
    v-model="show"
    max-width="800px"
    @click:outside="close()"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span class="headline">LendingTree Daily Cost Reports</span>
      </v-card-title>

      <v-container>
        <v-data-table-server
          v-model:options="options"
          dense
          :headers="headers"
          :loading="loading"
          :items="items"
          :items-length="totalItems"
          class="elevation-1"
          :items-per-page-options="footerProps.itemsPerPageOptions"
          @update:options="updateTable"
        />
      </v-container>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          @click="close()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableMixin.js';

export default {

  mixins: [
    dataTableMixin,
  ],

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      headers: [
        { title: 'Date', value: 'date' },
        { title: 'Total Offers', value: 'total_offers' },
        { title: 'Offers Cost', value: 'offers_cost' },
        { title: 'Total Converted', value: 'total_converted' },
        { title: 'Application Cost', value: 'application_cost' },
      ],
      loading: false,
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/lendingtree/cost-reports', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...(this.options.sortBy.length ? this.sortParams : { sortBy: ['date'], sortDesc: [true] }),
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },
    close() {
      this.options.page = 1;
      this.$emit('close-modal');
    },
  },
};
</script>
